$.fn.columnSpliter = function(max_column_count = 4) {
  let self = this
  self.current_column_count = 0;

  self.split_columns = function() {
    var window_width = $(window).width()
    if (window_width > 950) {
      self.new_column_count = max_column_count;
    } else if (window_width > 768) {
      self.new_column_count = 3;
    } else {
      self.new_column_count = 2;
    }

    if (self.new_column_count != self.current_column_count) {
      self.current_column_count = self.new_column_count;
      self.find('.column-spliter__column').children().unwrap();
      let modulo_last = self.find('> *').length % self.current_column_count
      self.find('.cols' + self.current_column_count + '_1').wrapAll('<div class="column-spliter__column" data-order="1" />');
      self.find('.cols' + self.current_column_count + '_2').wrapAll('<div class="column-spliter__column" data-order="2" />');
      self.find('.cols' + self.current_column_count + '_3').wrapAll('<div class="column-spliter__column" data-order="3" />');
      self.find('.cols' + self.current_column_count + '_4').wrapAll('<div class="column-spliter__column" data-order="4" />');
      self.find('.column-spliter__column').each(function() {
        var $wrapper = $(this);
        $wrapper.find('> *').sort(function(a, b) {
            return +a.dataset.order - +b.dataset.order;
        })
        .appendTo($wrapper);
      })
      self.removeClass('--cols-1');
      self.removeClass('--cols-2');
      self.removeClass('--cols-3');
      self.removeClass('--cols-4');
      self.addClass('--cols-' + self.current_column_count);

      if (self.hasClass('directors-menu__names')) {
        if (modulo_last == 2 || modulo_last == 3) {
          $('.column-spliter__column[data-order="' + self.current_column_count + '"]').append(self.last.detach())
        }
      }
    }
  }

  var cols_2 = 1;
  var cols_3 = 1;
  var cols_4 = 1;
  self.find('> *').each(function(index){
    $(this).addClass('cols2_' + cols_2);
    $(this).addClass('cols3_' + cols_3);
    $(this).addClass('cols4_' + cols_4);
    $(this).attr('data-order', index);
    cols_2++;
    cols_3++;
    cols_4++;
    if (cols_2 > 2) {cols_2 = 1}
    if (cols_3 > 3) {cols_3 = 1}
    if (cols_4 > 4) {cols_4 = 1}
    self.last = $(this)
  })

  return function() {
    $(window).on('resize load orientationchange', self.split_columns)
    self.split_columns()
    return self
  }()
}
